<!--
   Created by qing on 2020/2/18 4:17 下午
   Des:
-->
<template>
  <div v-if="filterWay">
    <SelectValue
      :disabled="disabled"
      :fields="fields"
      :isMultiple="isMultiple"
      :filterValue="filterValue"
      :filter="filter"
      :formId="formId"
      @change="filterChange">
    </SelectValue>
  </div>
  <div v-else class="filter-address">
    <van-field
      :disabled="disabled"
      :style="{backgroundColor: disabled ? '#F5F7FA' : '#fff'}"
      @change="filterChange"
      placeholder="请选择"
      right-icon="arrow"
      v-model="content"
      @focus="fieldFocus">
    </van-field>
    <van-popup
      v-model="show"
      :style="{ height: '40%' }"
      get-container="body"
      position="bottom">
      <van-area
          ref="addressPicker"
          title="选择地址"
          :area-list="areaList"
          :columns-placeholder="['请选择', '请选择', '请选择']"
          @cancel="show = false"
          @confirm="pickerConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
  import current from "./mixin"
  import {
    ADDRESS_TYPE__CITY,
    ADDRESS_TYPE__COUNTY,
    ADDRESS_TYPE__DETAIL,
    ADDRESS_TYPE__PROVINCE
  } from "../../../RyForm/types";
  import {countyOptions} from "../../../../assets/js/Untis";
  import { areaList } from '@vant/area-data';

  export default {
    mixins: [current],
    data() {
      return {
        areaList,
        show: false,
        addressOpts: [],
        ADDRESS_TYPE__DETAIL
      };
    },
    computed: {
      columns () {
        if (!this.addressOpts.length) {
          this.addressOpts = countyOptions()
        }
        return this.addressOpts
      },
      content: {
        get () {
          return this.filterValue.join('/')
        },
        set () {}
      },
    },
    methods: {

      fieldFocus (event) {
        if (this.disabled) return
        this.openPicker()
        event.target.blur()
      },
      pickerConfirm (result) {
        this.filterValue.splice(0, this.filterValue.length)
        result.forEach(item => {
          if (item && item.name) {
            this.filterValue.push(item.name)
          }
        })
        // this.current.splice(0, this.current.length, ...result)
        this.show = false
        this.filterChange()
      },
      openPicker () {
        this.show = true
        // this.$nextTick(() => {
        //   this.$refs.addressPicker.setValues(this.current)
        // })
      }
    }
  };
</script>

<style lang="less">

  .filter-address {
    .van-field {
      height: 32px !important;
    }
  }
</style>
